import React from 'react';
import Fab from '@material-ui/core/Fab';

export default (props) => (
    <Fab variant="extended" {...props}>
        {props.children}
    </Fab>
);